
__webpack_require__.debugRequireIds = {
	"-!./debug-require.cjs": 2800,
	"./debug-require.cjs": 70112,
	"./src/base_page_params.ts": 30330,
	"./src/blueslip.ts": 82216,
	"./src/blueslip_stacktrace.ts": 94574,
	"./src/bot_types.ts": 23979,
	"./src/bundles/common.ts": 48861,
	"./src/bundles/marketing_page_bundle.ts": 36245,
	"./src/csrf.ts": 15996,
	"./src/portico/google-analytics.ts": 49533,
	"./src/portico/header.ts": 67146,
	"./src/realm_user_settings_defaults.ts": 14414,
	"./src/sentry.ts": 54405,
	"./src/state_data.ts": 89704,
	"./src/stream_types.ts": 85084,
	"./src/types.ts": 68521,
	"./src/user_settings.ts": 77745,
	"./src/user_status_types.ts": 87856,
	"./styles/portico/comparison_table.css": 43880,
	"./styles/portico/marketing_page.css": 9504,
	"./styles/portico/portico_variables.css": 16106,
	"./styles/portico/pricing_plans.css": 79819,
	"./templates/blueslip_stacktrace.hbs": 84856,
	"./templates/team/contributor_count.hbs": 5369,
	"./templates/team/contributors.hbs": 92786,
	"./templates/team/loading.hbs": 6862,
	"./templates/team/total_contributor_count.hbs": 97246,
	"@formatjs/fast-memoize": 96140,
	"core-js/modules/es.array-buffer.detached.js": 29995,
	"core-js/modules/es.array-buffer.transfer-to-fixed-length.js": 550,
	"core-js/modules/es.array-buffer.transfer.js": 28754,
	"core-js/modules/es.array.push.js": 4356,
	"core-js/modules/es.iterator.constructor.js": 7913,
	"core-js/modules/es.iterator.filter.js": 94879,
	"core-js/modules/es.iterator.find.js": 60578,
	"core-js/modules/es.iterator.flat-map.js": 61781,
	"core-js/modules/es.iterator.map.js": 61615,
	"core-js/modules/es.iterator.reduce.js": 13747,
	"core-js/modules/es.iterator.some.js": 63305,
	"core-js/modules/es.json.parse.js": 34478,
	"core-js/modules/es.json.stringify.js": 17904,
	"core-js/modules/es.map.get-or-insert-computed.js": 9537,
	"core-js/modules/es.map.get-or-insert.js": 36561,
	"core-js/modules/es.set.difference.v2.js": 41952,
	"core-js/modules/es.set.intersection.v2.js": 30142,
	"core-js/modules/es.set.is-disjoint-from.v2.js": 31863,
	"core-js/modules/es.set.is-subset-of.v2.js": 31790,
	"core-js/modules/es.set.is-superset-of.v2.js": 49173,
	"core-js/modules/es.set.symmetric-difference.v2.js": 64618,
	"core-js/modules/es.set.union.v2.js": 39796,
	"core-js/modules/es.typed-array.with.js": 95747,
	"core-js/modules/es.uint8-array.set-from-base64.js": 82474,
	"core-js/modules/es.uint8-array.set-from-hex.js": 94188,
	"core-js/modules/es.uint8-array.to-base64.js": 82140,
	"core-js/modules/es.uint8-array.to-hex.js": 45342,
	"core-js/modules/web.url-search-params.delete.js": 17361,
	"core-js/modules/web.url-search-params.has.js": 46860,
	"core-js/modules/web.url-search-params.size.js": 27351,
	"error-stack-parser": 69363,
	"ga-gtag": 78406,
	"handlebars/runtime.js": 81942,
	"jquery": 63150,
	"lodash": 96749,
	"minimalistic-assert": 45185,
	"source-map": 68068,
	"stackframe": 36854,
	"stacktrace-gps": 14021,
	"zod/mini": 15729
};